export const zdarKidsCustomCiphers = {
    understairs: 'understairs',
    pond: 'pond',
    bridge: 'bridge',
    pexeso: 'pexeso',
    church: 'church',
};
